import { Switch } from "@frontend/components/ui/switch"
import type { TileViewer } from "@virdx/wsi-viewer"
import { useCallback, useState } from "react"

interface HistoViewerToolbarProps {
  viewerRef: React.RefObject<TileViewer | null>
}

export function HistoViewerToolbar({ viewerRef }: HistoViewerToolbarProps) {
  const [minimapEnabled, setMinimapEnabled] = useState(true)

  const handleToggleMinimap = useCallback(
    (checked: boolean) => {
      viewerRef.current?.setMinimapEnabled(checked)
      setMinimapEnabled(checked)
    },
    [viewerRef]
  )

  return (
    <div className="flex items-center justify-end gap-2">
      <label className="flex items-center gap-1.5 text-[11px] text-muted-foreground">
        Minimap
        <Switch size="sm" className="px-0.5" checked={minimapEnabled} onCheckedChange={handleToggleMinimap} />
      </label>
    </div>
  )
}
